import Logger from "../../../clients/logger";
import ConfigClient from "../../../clients/configClient";
import InteropAdmin from "../../../clients/Interop/InteropAdmin";
import { BootTaskCallbackInterface } from "../types";

const interopAdmin = new InteropAdmin();

/**
 * Boot task that initially adds all the appD definitions to the InteropService. The same will happen in the configService if a processAndSet adds more apps to config.
 * @private
 */
export class AddAppDefinitionsToDesktopAgentTask {
	public async start(doneCallback: BootTaskCallbackInterface) {
		Logger.system.log(`AddAppDefinitionsToDesktopAgentTask startup`);
		let { data: appDConfig } = await ConfigClient.getValue({ field: "finsemble.appd" });
		await interopAdmin.addAppDefinitions(appDConfig);
		doneCallback("addAppDefinitionsToDesktopAgentTask", "bootTasks", "completed");
	}
}
